export default __webpack_public_path__ + "static/media/Descargar-compulsa.8e07b360.svg";